


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';

@Component({
    components: {
        Icon,
    },
})
export default class NumberPicker extends Vue {
  @Prop({ default: 0 }) private value!: number;
  @Prop({ default: 0 }) private minNumber!: number;
  @Prop({ default: 99 }) private maxNumber!: number;
  @Prop({ default: false }) private disableMax !: boolean;


  private iconEnum = IconEnum;


  get hasValue() {
      return this.value !== 0;
  }

  get isMinValue() {
      return this.value === this.minNumber;
  }

  get isMaxValue() {
      return this.value === this.maxNumber;
  }


  private substract() {
      const newValue = this.value - 1;
      this.emitValue(newValue);
      if (newValue === this.minNumber) {
          this.$emit('min-value');
      }
  }

  private add() {
      const newValue = this.value + 1;
      this.emitValue(newValue);
      if (newValue === this.maxNumber) {
          this.$emit('max-value');
      }
  }

  private emitValue(value: number) {
      this.$emit('input', value);
  }
}

